/**
 * Extracts and validates the 'id' field from the given API response object.
 *
 * @param res The API response object to extract the 'id' from.
 * @returns The 'id' string if valid, otherwise `null`.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function extractIDFromResponse(res: any): string | null {
  // Check if 'res' and 'res.data' are not null or undefined
  if (!res || !res.data) {
    return null;
  }

  // Check if the 'res.data' object has a string 'id' field longer than 1 character
  if (typeof res.data.id === 'string' && res.data.id.length > 1) {
    return res.data.id;
  }

  return null;
}
